// ============================================================
// Toast — kurze Erfolgsmeldung
// ============================================================

import { Icon } from '../icons';
import { useApp } from '../store';

export function Toast() {
  const { toast } = useApp();
  if (!toast) return null;
  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 90,
        background: '#1c211d',
        color: '#fff',
        padding: '12px 20px',
        borderRadius: 10,
        fontSize: 13,
        fontWeight: 500,
        boxShadow: '0 10px 30px rgba(0,0,0,.3)',
        animation: 'wlPop .2s ease',
        display: 'flex',
        alignItems: 'center',
        gap: 9,
      }}
    >
      <Icon name="check" color="#7fd39a" size={16} />
      {toast.msg}
    </div>
  );
}
